<div class="onmat-errors">
  <header class="onmat-errors__header">
    <svg-icon key="logo-onmat" class="onmat-errors__logo"></svg-icon>
  </header>
  <div class="h-full">
    <div class="onmat-errors__body">
      <img src="{{ errorInfo?.img }}" class="onmat-errors__image" />
      <div class="error-message">
        <h1 class="error-message__title" [innerHTML]="errorInfo?.title | translate"></h1>
        <p class="error-message__text" [innerHTML]="errorInfo?.description | translate"></p>
        <div *ngIf="errorInfo?.button">
          <button (click)="redirectUrl()" class="error-message__button btn btn-primary" translate>
            <svg-icon key="icon-refresh" class="error-message__icon"></svg-icon>
            {{ errorInfo?.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
